import { render, staticRenderFns } from "./CityVehicleStatusListEdit.vue?vue&type=template&id=66227fb8&"
import script from "./CityVehicleStatusListEdit.vue?vue&type=script&lang=js&"
export * from "./CityVehicleStatusListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports